export default {
  createSuccess: "Venditore creato con successo!",
  createModal: {
    title: "Aggiungi venditore",
    namePlaceholder: "es. Acme Tours",
    emailPlaceholder: "seller@example.com",
    create: "Crea venditore",
  },
  detail: {
    loadSeller: "Caricamento dettagli venditore...",
    loadError: "Impossibile caricare il venditore",
    roleLabel: "Venditore",
    statActivities: "Attività",
    bookingsCardTitle: "Prenotazioni",
    seeBookings: "Vedi prenotazioni",
    toastPasswordResetSent: "Email di reset password inviata al venditore.",
    activitiesTitle: "Attività ({{count}})",
    addActivity: "Aggiungi attività",
    loadActivities: "Caricamento attività...",
    activitiesError: "Errore nel caricamento delle attività",
    noActivitiesTitle: "Nessuna attività",
    noActivitiesDesc: "Questo venditore non ha ancora attività",
    toastStatusUpdated: "Stato venditore aggiornato",
    toastStatusError: "Impossibile aggiornare lo stato",
    categoryRestaurant: "Ristorante",
    categoryService: "Servizio",
    categoryAttraction: "Attrazione",
    activityCommission: "Commissione",
  },
} as const;
